export const apiPaths = {
  sites: {
    getAll: 'Site',
    getSiteList: 'Site/Details',
    favorite: ({ siteId }: { siteId: string }) => `Site/favourite/${siteId}`,
    favoriteAll: `Site/favourite`,
    find: ({ searchText }: { searchText: string }) => `Site/Find/${searchText}`,
    note: ({ siteId }: { siteId: string }) => `Site/${siteId}/Note`,
    notes: ({ siteId }: { siteId: string }) => `Site/${siteId}/Notes`,
    lns: ({ siteId }: { siteId: string }) => `Site/${siteId}/LnsTrend`,
    dmas: ({ siteId }: { siteId: string }) => `Site/${siteId}/Dmas`,
    histogram: ({ siteId, range }: { siteId: string; range: string }) => `Site/${siteId}/Histogram/${range}`,
    csq: ({ siteId }: { siteId: string }) => `Site/${siteId}/Csq`,
    signal: ({ siteId }: { siteId: string }) => `Site/${siteId}/Signal`,
    ownerChange: 'Site/Owner',
    details: ({ siteId }: { siteId: string }) => `Site/${siteId}/Details`,
    orientation: ({ siteId }: { siteId: string }) => `Site/${siteId}/orientation`,
    correlationList: ({ siteId, accountId }: { siteId: string; accountId: string }) =>
      `Site/${siteId}/Correlations?accountId=${accountId}`,
    photo: ({ siteId, photoId }: { siteId: string; photoId?: string }) => `Site/${siteId}/photo/${photoId ?? ''}`,
    photos: ({ siteId }: { siteId: string }) => `Site/${siteId}/photo`,
    saveLocation: ({ siteId }: { siteId: string }) => `Site/${siteId}/Location`,
    audio: ({ siteId }: { siteId: string }) => `Site/${siteId}/Recordings`,
    audioList: ({ siteId }: { siteId: string }) => `Site/${siteId}/Recordings/List`,
    audioElectricalNoise: ({ siteId, recordingId }: { siteId: string; recordingId: string }) =>
      `Site/${siteId}/Recordings/${recordingId}/ElectricalNoise`,
    commands: ({ siteId, commandType }: { siteId: string; commandType: string }) =>
      `Site/${siteId}/commands?commandType=${commandType}`,
    siteAudit: ({ siteId }: { siteId: string }) => `Site/${siteId}/history`,
    siteAuditCsv: ({ siteId }: { siteId: string }) => `Site/${siteId}/history/Csv`,
    siteLoggerDisassociate: ({ siteId }: { siteId: string }) => `Site/${siteId}/DisassociateLogger`,
    fleetReport: () => 'Site/FleetReport',
    csv: () => 'Site/Csv',
    thresholdChange: () => 'Site/Threshold',
    loggerProgramChange: () => 'Site/SoundRecordingOptions',
    loggerModeChange: () => 'Site/LoggerMode',
    recycle: 'Site/Recycle',
    disassociateLoggers: () => 'Site/DisassociateLoggers',
    unassigned: `Site/Unassigned`,
    commonDmas: `Site/CommonDmas`,
    clusters: 'Site/Clusters',
    filteredSelectedIds: `Site/Details/FilteredSelectedIds`,
    numberOfSitesOnMap: 'Site/NumberOfSitesOnMap',
    detailsJobPack: 'Site/JobPack',
    detailsJobPackShare: 'Site/JobPack/Share',
    uploadSiteNotes: 'Site/upload/siteNotes',
    // new Leaks
    newLeaks: 'Site/NewLeaks',
    newLeaksCsv: 'Site/NewLeaks/Csv',
    NewLeaksSchedule: 'Site/NewLeaks/Csv/Schedule',
    newLeaksStats: 'Site/NewLeaks/Statistics',
    newLeaksBreakdown: 'Site/NewLeaks/StatisticsBreakdown',
    newLeaksJobPack: 'Site/NewLeaks/JobPack',
    newLeaksJobPackShare: 'Site/NewLeaks/JobPack/Share',
    //leak Analysis
    leakAnalysis: 'Site/LeakAnalysis',
    leakAnalysisExport: 'Site/LeakAnalysis/Report',
    leakAnalysisUpdate: ({ siteId }: { siteId: string }) => `Site/LeakAnalysis/${siteId}`,
    // threshold modelling
    thresholdModelling: 'Site/ThresholdModeling',
    thresholdModellingProgram: 'Site/ThresholdModeling/Program',
    // linked sites
    linkedSites: 'Site/LinkedFlowSites',
    linkedSiteFlowData: ({ flowDataId }: { flowDataId: string | number }) =>
      `Site/LinkedFlowSites/${flowDataId}/FlowData`,
  },
  maintenance: {
    maintenanceTable: (accountId: number) => `Maintenance/${accountId}`,
    maintenanceDonutGraph: (accountId: number) => `Maintenance/Graph/${accountId}`,
    maintenanceTrend: (accountId: number) => `Maintenance/Trend/${accountId}`,
    csv: (accountId: number) => `Maintenance/${accountId}/Csv`,
  },
  loggers: {
    saveProgram: ({ loggerId }: { loggerId: string }) => `Logger/${loggerId}/SoundRecordingOptions`,
    getProgram: ({ loggerId }: { loggerId: string }) => `Logger/${loggerId}/SoundRecordingOptions`,
    getLnsDeterminationTimes: `Logger/LnsDeterminationTimes`,
    getDeploymentReport: 'Logger/DeploymentReport',
    deploymentReportCsv: 'Logger/DeploymentReportCsv',
    getAudioFilter: ({ loggerId }: { loggerId: string }) => `Logger/${loggerId}/AudioFilter`,
    saveAudioFilter: ({ loggerId }: { loggerId: string }) => `Logger/${loggerId}/AudioFilter`,
  },
  correlations: {
    calculate: ({ correlationId }: { correlationId: string }) => `Correlation/${correlationId}/Calculate`,
    leakPath: ({ correlationId }: { correlationId: string }) => `Correlation/${correlationId}/LeakPath`,
    details: ({ correlationId, accountId }: { correlationId: string; accountId: string }) =>
      `Correlation/${correlationId}?accountId=${accountId}`,
    shareDiagram: ({ correlationId }: { correlationId: string }) => `Correlation/${correlationId}/ShareDiagram`,
    shareReport: 'Correlation/ShareReport',
    delete: ({ correlationId }: { correlationId: string }) => `Correlation/${correlationId}`,
    pipeSections: ({ correlationId }: { correlationId: string }) => `Correlation/${correlationId}/PipeSections`,
    comments: ({ correlationId }: { correlationId: string }) => `Correlation/${correlationId}/Comments`,
    setCustomPipes: `Correlation/CustomCorrelationPath`,
    pipeMaterialsAndSizes: 'Correlation/PipeMaterialsAndSizes',
    correlation: 'Correlation',
    manual: 'Correlation/Manual',
    multi: 'Correlation/MultiCorrelation',
    pending: 'Correlation/Pending',
    updateManualCorrelation: ({ correlationId }: { correlationId: string }) => `Correlation/${correlationId}/Manual`,
    exportCorrelations: ({ correlationType }: { correlationType: string }) => `Correlation/${correlationType}/Csv`,
    actioned: ({ correlationId }: { correlationId: string }) => `Correlation/${correlationId}/Actioned`,
  },
  correlationProcess: {
    delete: ({ correlationProcessId }: { correlationProcessId: string }) =>
      `CorrelationProcess/${correlationProcessId}`,
  },
  statistics: {
    averageRuntime: ({ accountId }: { accountId: string }) =>
      accountId ? `AccountsStatistics/AverageRuntime/${accountId}` : 'AccountsStatistics/AverageRuntime',
    breakdown: ({ accountId }: { accountId: string }) =>
      accountId ? `AccountsStatistics/Breakdown/${accountId}` : 'AccountsStatistics/Breakdown',
    breakdownTrend: ({ accountId }: { accountId: string }) =>
      accountId ? `AccountsStatistics/BreakdownTrend/${accountId}` : 'AccountsStatistics/BreakdownTrend',
    exportBreakdownTrend: ({ accountId }: { accountId: string }) =>
      accountId && `AccountsStatistics/BreakdownTrend/${accountId}/Csv`,
    devices: ({ accountId }: { accountId: string }) =>
      accountId ? `AccountsStatistics/Devices/${accountId}` : 'AccountsStatistics/Devices',
  },
  leaks: {
    sitesToAssociate: `LeakConfirmation/SitesToAssociate`,
    pipeMaterials: `LeakConfirmation/PipeMaterials`,
    pipeSizes: `LeakConfirmation/PipeSizes`,
    leakConfirmation: ({ leakId }: { leakId: string }) => `LeakConfirmation/${leakId}`,
    createLeakConfirmation: 'LeakConfirmation',
    updateLeakConfirmation: ({ leakId }: { leakId?: string }) => `LeakConfirmation/${leakId}`,
    addPhoto: ({ leakId }: { leakId: string }) => `LeakConfirmation/${leakId}/Photo`,
    deletePhoto: ({ leakId, id }: { leakId: string; id: string }) => `LeakConfirmation/${leakId}/Photo/${id}`,
    csv: 'LeakConfirmation/Csv',
    delete: ({ leakId }: { leakId: string }) => `LeakConfirmation/${leakId}`,
    calculate: 'LeakConfirmation/Calculate',
  },
  accounts: {
    createDma: `Account/dma`,
    correlationList: ({ accountId }: { accountId: string }) => `Account/${accountId}/Correlations`,
    correlationPaths: ({ accountId }: { accountId: string }) => `Account/${accountId}/CorrelationPaths`,
    lnsCsv: ({ accountId }: { accountId: string }) => `Account/${accountId}/LnsSummary/Csv`,
    getLeaks: ({ accountId }: { accountId: string }) => `Account/${accountId}/LeakConfirmations`,
    mainAccount: 'Profile',
    permissions: 'Profile/Permissions',
    subaccounts: ({ accountId, includeArchived }: { accountId?: string; includeArchived: boolean }) =>
      `Account/Subaccounts?includeArchived=${String(includeArchived)}${accountId ? `&accountId=${accountId}` : ''}`,
    getForAutocomplete: ({
      searchQuery,
      accountType,
      includeArchived,
    }: {
      searchQuery: string;
      accountType?: string;
      includeArchived?: boolean;
    }) =>
      `Account/Dictionary?NameContains=${searchQuery}${
        (accountType && `&Type=${accountType}`) ?? ''
      }${includeArchived ? `&IncludeArchived=true` : ''}`,
    getPotentialParents: ({ accountId, searchQuery }: { accountId: string; searchQuery: string }) =>
      `Account/Parents?NameContains=${searchQuery}&AccountId=${accountId}`,
    getById: ({ accountId }: { accountId: string }) => `Account/${accountId}`,
    getDmaSummary: ({ accountId }: { accountId?: string }) =>
      accountId ? `Account/${accountId}/Dmas` : 'Account/Dmas',
    getDmaSummaryCSV: ({ accountId }: { accountId: string }) => `Account/${accountId}/Dmas/csv`,
    lnsSummary: ({ accountId }: { accountId: string }) => `Account/${accountId}/LnsSummary`,
    getAccountDetails: ({ accountId }: { accountId: string }) => `Account/${accountId}/Details`,
    accountSettings: ({ accountId }: { accountId: string }) => `Account/${accountId}/Settings`,
    namedList: ({ accountId, listId }: { accountId?: string; listId?: string }) =>
      `Account/${accountId ? `${accountId}/` : ''}SitesNamedlist${listId ? `/${listId}` : ''}`,
    favoriteNamedList: `Account/favourite/lists/load`,
    createNamedList: ({ accountId }: { accountId: string }) => `Account/${accountId}/CreateSitesNamedlist`,
    getPipes: ({ accountId }: { accountId: string }) => `Account/${accountId}/Pipes`,
    getAssets: ({ accountId }: { accountId: string }) => `Account/${accountId}/Assets`,
    getSurveyMeasurements: ({ accountId }: { accountId: string }) => `accounts/${accountId}/surveys`,
    allIds: ({ accountId }: { accountId: string }) => `Account/${accountId}/LnsSummary/AllIds`,
    associatedAccounts: ({ accountId }: { accountId?: string }) =>
      `Account/AssociatedAccounts${accountId ? `?accountId=${accountId}` : ''}`,
    unassignSites: `Account/UnassignSites`,
    assignSites: `Account/AssignSites`,
    accountAudit: ({ accountId }: { accountId: string }) => `Account/${accountId}/SitesHistory`,
    accountAuditCsv: ({ accountId }: { accountId: string }) => `Account/${accountId}/SitesHistory/Csv`,
    logo: ({ accountId }: { accountId: string }) => `Account/${accountId}/Logo`,
    preferences: ({ accountId }: { accountId: string }) => `Account/${accountId}/Preferences`,
    hasFlowLinks: ({ accountId }: { accountId: string }) => `Account/${accountId}/hasFlowLinks`,
  },
  audio: {
    graph: 'Audio/AudioGraph',
    recording: ({ recordingId }: { recordingId: string }) => `Audio/Recording/${recordingId}`,
  },
  audioAnalysis: {
    summary: `LeakAudioAnalysis/AllRequests`,
    detailsList: `LeakAudioAnalysis/RequestDetails`,
    details: ({ analysisId }: { analysisId: string | number }) => `LeakAudioAnalysis/Analyses/${analysisId}`,
    request: `LeakAudioAnalysis`,
  },
  gis: {
    boundaries: ({ accountId }: { accountId: string }) => `Account/${accountId}/Boundaries`,
    upload: 'gis/imports/Upload', //
    materialTypes: 'gis/imports/pipeMaterialTypes', //
    assetTypes: 'gis/imports/assetTypes', //
    imports: 'gis/imports', //import list
    detailedImport: ({ importId }: { importId: string }) => `gis/imports/${importId}`, //
    importsProperties: 'gis/imports/mappings/properties/default', //
    importsMaterialCodes: 'gis/imports/mappings/materialCodes/default', //
    changeImportProperties: ({ importId }: { importId: string }) => `gis/imports/${importId}/mappings/properties`, //
    changeImportMaterialCodes: ({ importId }: { importId: string }) => `gis/imports/${importId}/mappings/materialCodes`, //
  },
  users: {
    get: ({ text }: { text: string }) => `User?text=${text}`,
    current: 'User/Current',
    getAccessProfile: ({ id }: { id: number }) => `User/${id}/accessProfile`,
    getById: ({ id }: { id: number }) => `user/${id}`,
  },
  translations: {
    translations: 'translations',
    live: (languageCode: string) => `${apiPaths.translations.translations}/live/${languageCode}`,
  },
  featureFlags: {
    features: `/features/account`,
  },
  utils: {
    pdf: 'Pdf',
  },
  linkedAccounts: {
    linkedAccounts: ({ accountId }: { accountId: string }) => `LinkedAccounts/${accountId}`,
    linkedAccountsDmas: ({ accountId }: { accountId: string }) => `LinkedAccounts/${accountId}/dmaAccountsToLink`,
    linkedAccountsGuests: ({ accountId }: { accountId: string }) => `LinkedAccounts/${accountId}/guestAccountsToLink`,
    linkedAccountsLink: ({ accountId, guestAccountId }: { accountId: string; guestAccountId: string }) =>
      `LinkedAccounts/${accountId}/link/${guestAccountId}`,
    linkedAccountsFlowData: ({ accountId }: { accountId: string }) => `LinkedAccounts/${accountId}/flowData`,
  },
  preferences: {
    preferences: 'Preferences',
  },
  functions: {
    bulk: 'Functions/Bulk',
  },
  surveys: {
    surveysList: 'Surveys',
    surveysMap: 'Surveys/Map',
    surveyDetails: ({ surveyId }: { surveyId: string }) => `Surveys/${surveyId}`,
    surveyClone: ({ surveyId }: { surveyId: string }) => `Surveys/${surveyId}/Clone`,
    //
    surveyCorrelationDetails: ({ surveyId, correlationId }: { surveyId: string; correlationId: string }) =>
      `Surveys/${surveyId}/Correlations/${correlationId}`,
    surveyNotes: ({ surveyId }: { surveyId: string }) => `Surveys/${surveyId}/Notes`,
  },
};
